/**
 * Map from days of the week to their abbreviations
 */
const DAY_MAP = {
    sunday: "Su",
    monday: "M",
    tuesday: "T",
    wednesday: "W",
    thursday: "Th",
    friday: "F",
    saturday: "Sa",
};
export default class CourseSectionScheduleElementService {
    /**
     * Generates the week part of the display string for a schedule element
     *
     * @param {CourseSectionScheduleElementDto} elm - the schedule element
     * @param {string} delimiter - (optional) the character to show in-between days **(avoid. should only be used in rare cases)**
     * @returns {string} weekly display string
     */
    static getWeekDisplayString(elm, delimiter = "") {
        // For every key in the DAY_MAP constant
        return (Object.keys(DAY_MAP)
            // See if the day exists on the schedule element
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CourseSectionScheduleElementDto'.
            .filter((key) => elm[key])
            // get the value (abbreviation)
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly sunday: "Su"; readonly monday: "M"; readonly tuesday: "T"; readonly wednesday: "W"; readonly thursday: "Th"; readonly friday: "F"; readonly saturday: "Sa"; }'.
            .map((key) => DAY_MAP[key])
            // join these together with the delimiter
            .join(delimiter));
    }
    /**
     * Generates the time part of the display string for a schedule element.
     *
     * @param {number} hours - 24 hour value
     * @param {number} minutes - minutes
     * @returns {string} time display string
     */
    static getTimeDisplayString(hours, minutes = 0) {
        if (hours == null) {
            if (console.warn) {
                console.warn(`Passed invalid value ${hours} as hours to CourseSectionScheduleElementService.getTimeDisplayString`);
            }
            return "";
        }
        const isAm = hours < 12;
        const hour = hours % 12 || 12;
        const minuteString = minutes < 10 ? "0" + minutes : minutes.toString();
        return `${hour}:${minuteString} ${isAm ? "AM" : "PM"}`;
    }
    /**
     * Get display string for a course section schedule element
     *
     * @param {CourseSectionScheduleElementDto} elm - the schedule element
     * @returns {string} the display string
     */
    static getDisplayString(elm) {
        return (CourseSectionScheduleElementService.getWeekDisplayString(elm) +
            " " +
            CourseSectionScheduleElementService.getTimeDisplayString(elm.startTimeHours24, elm.startTimeMinutes24) +
            " - " +
            CourseSectionScheduleElementService.getTimeDisplayString(elm.endTimeHours24, elm.endTimeMinutes24));
    }
    static getDaysSet(elm) {
        // @ts-expect-error - TS2322 - Type 'Set<string>' is not assignable to type 'Set<"sunday" | "monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday">'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CourseSectionScheduleElementDto'.
        return new Set(Object.keys(DAY_MAP).filter((key) => elm[key]));
    }
}
